<template>
<div class="page_iteminfo">
	<div class="item_top">
		<img :src="info.dianpu_image ? imageUrl+info.dianpu_image : $publicData.defalutFengmian" alt="" class="bg">
		<div class="item_top_info">
			<div class="tag">{{info.nickname}}</div>
			<div class="desc" :style="info.special_thumb ? 'background: rgba(0,0,0,.5);': 'background: rgba(0,0,0,.2);'">{{info.describe}}</div>
		</div>
	</div>
	<!-- 介绍 -->
	<div class="jieshao" v-html="info.info"></div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            tradesmanId: this.$route.query.tradesmanId,
            info: {}, // 用户信息
			token:null,
			shareConfig: null // 分享的相关配置
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {'data':{'naviTitle':'匠人介绍'}}
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {
					notCallLogin: 1,
                }
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                } else {
                    this.token = 
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function() {
        
    },
    methods: {
        getData() {
            this.getDetail()
        },
        getDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res=>{
                if (res.code == 200) {
                    var info = res.result
					this.info = info
					// 调起 获取微信分享参数函数
					this.getShareData()
                } else {
                    this.$toast(res.message)
                }
            })
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA, // 分享标题
					desc: that.info.describe ? that.info.describe : '', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.info.dianpu_image ? that.$publicData.imageUrl + that.info.dianpu_image : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
